import { render, staticRenderFns } from "./menuMore.vue?vue&type=template&id=7ba6ddda&scoped=true&"
import script from "./menuMore.vue?vue&type=script&lang=js&"
export * from "./menuMore.vue?vue&type=script&lang=js&"
import style0 from "./menuMore.vue?vue&type=style&index=0&id=7ba6ddda&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ba6ddda",
  null
  
)

export default component.exports